import type { FC } from 'react';

import { CONTACT } from '@/constants/site.constants';
import { SECTION_IDS } from '@/features/home/constants/home.constants';
import { SITE_CONTAINER } from '@/features/home/constants/homeStyles.constants';
import type { DownloadCopy, StoreBadge } from '@/types/home.types';

interface DownloadCtaProps {
  copy: DownloadCopy;
  badges: StoreBadge[];
}

const DownloadCta: FC<DownloadCtaProps> = ({ copy, badges }) => (
  <section id={SECTION_IDS.download} className="scroll-mt-16 bg-site-accent text-white">
    <div
      className={`${SITE_CONTAINER} grid grid-cols-[repeat(auto-fit,minmax(min(100%,420px),1fr))] items-end gap-12 py-16 md:py-20`}
    >
      <div>
        <h2 className="-ml-[0.05em] font-site text-[clamp(44px,5.6vw,76px)] leading-[1.02] font-extrabold tracking-[-0.025em]">
          <span className="block">{copy.lead}</span>
          <span className="block">{copy.accent}</span>
        </h2>
        <p className="mt-7 max-w-[30ch] font-site text-2xl leading-[1.35] font-bold">
          {copy.note}{' '}
          <a href={`mailto:${CONTACT.email}`} className="underline underline-offset-4">
            {CONTACT.email}
          </a>
        </p>
      </div>

      <div className="flex flex-wrap gap-5">
        {badges.map((badge) => (
          <a
            key={badge.platform}
            href={badge.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-[200px] max-w-full flex-col gap-3.5 bg-white p-4 text-site-ink outline-site-ink transition-[outline] hover:outline-[3px]"
          >
            <img
              src={badge.qrSrc}
              alt={badge.qrAlt}
              width={168}
              height={168}
              loading="lazy"
              className="block h-auto w-full"
            />
            <span className="flex items-baseline justify-between">
              <span className="font-site text-[18px] font-extrabold">{badge.storeName}</span>
              <span className="font-site text-[12px]">{badge.osLabel} ↗</span>
            </span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default DownloadCta;
